export const coral = {
  900: '#c7000b',
  800: '#d7001a',
  700: '#e40d22',
  600: '#f62027',
  500: '#ff2e26',
  400: '#ff4646',
  300: '#f46c6d',
  200: '#fa9796',
  100: '#ffcbd1',
  50: '#ffeaee',
};

export const blue = {
  50: '#e1f1fe',
  100: '#b7dcfd',
  200: '#87c7fc',
  300: '#52b1fb',
  400: '#18A0FB',
  500: '#0090fa',
  600: '#0082ec',
  700: '#0070d8',
  800: '#005fc7',
  900: '#0041a6',
};

export const grey = {
  50: '#f6f6f6',
  100: '#f3f3f3',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#aaa',
  500: '#999',
  600: '#888',
  700: '#777',
  800: '#444',
  900: '#222',
  A100: '#dddddf',
  A200: '#aaa',
  A400: '#333',
  A700: '#666',
};

export const red = {
  900: '#d12a00',
  800: '#e93a0d',
  700: '#f74212',
  600: '#ff4a18',
  500: '#ff501d',
  400: '#ff6d40',
  300: '#ff8963',
  200: '#ffab90',
  100: '#ffccbc',
  50: '#fee9e7',
};

export const green = {
  900: '#007500',
  800: '#009700',
  700: '#00ac00',
  600: '#00c000',
  500: '#15d100',
  400: '#55d941',
  300: '#7de069',
  200: '#a6ea97',
  100: '#cbf2c0',
  50: '#eafae6',
};
